import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import Header from "./header/header";
import Footer from "./Footer";
import "./WebinarForm.css";
import { z, ZodType } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import countryList from "react-select-country-list";
import { ClipLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import { BsEmojiFrown } from "react-icons/bs";
import { baseUrl, GetToken } from "../App";
import {
  checkAndGetThreeDays,
  checkAndGetOneHour,
} from "../HelperFunctions/helpers";

type FormData = {
  name: string;
  email: string;
  inputRequest?: string;
};

const WebinarForm: React.FC = () => {
  const [ready, setReady] = useState(false);
  const [sex, setSex] = useState("");
  const [softque, setSoftque] = useState("");
  const [webinarId, setWebinarId] = useState("");
  const [webinartopic, setWebinartopic] = useState("");
  const [webinarDate, setWebinarDate] = useState("");
  const [webinarPlatform, setWebinarPlatform] = useState("");
  const [webinarPhone, setWebinarPhone] = useState("");
  const [webinarEmail, setWebinarEmail] = useState("");
  const [inputName, setInputName] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [inputCountry, setInputCountry] = useState("");
  const [inputRequest, setInputRequest] = useState("");
  const [inputphone, setInputphone] = useState("");
  const [nophoneerror, setNophoneerror] = useState(true);
  const [error, setError] = useState("");
  const [webinarImage, setWebinarImage] = useState("");
  const [disablebutton, setDisablebutton] = useState(false);
  const [linkaddress, setLinkaddress] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [eventMeetingId, setEventMeetingId] = useState("");
  const [eventPasscode, setEventPasscode] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [newsLetter, setNewsLetter] = useState(false);
  // let params: any = useParams();
  let location = useLocation();
  const params = useParams();
  const [valueCountry, setValueCountry] = useState("");
  const options = useMemo<any>(() => countryList().getData(), []);
  const [showModal, setShowModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("");

  // Function to get error message based on error type
  const getErrorMessage = (error: any) => {
    if (!error.response) {
      return "Network Error: Unable to connect to the server. Please check your internet connection.";
    }
    const statusCode = error.response.status;
    switch (statusCode) {
      case 500:
        return "Oops, there is a slight issue with our server, please refresh or try again in a moment.";
      case 400:
        return "Sorry, our server cannot process your input. Please confirm your input.";
      case 403:
        return "You do not have permission to access this resource.";
      case 404:
        return "Your requested resource could not be found on the server.";
      default:
        return `Error ${statusCode}: An error occurred. Please try again later.`;
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setModalContent(""); // Reset modal content
  };

  const subscribetonewsletter = () => {
    setNewsLetter(!newsLetter);
  };

  const changeHandler = (value: any) => {
    setValueCountry(value);
    setInputCountry(value["label"]);
  };

  useEffect(() => {
    const fetch = async () => {
      const idToken = await GetToken();
      let Id: string = "";
      if (location?.state?.Id) {
        Id = location.state.Id;
      } else {
        const currentDate = new Date();

        // 1. Fetch data
        const { data: webinars } = await axios.get(`${baseUrl}/webinar`, {
          headers: { Authorization: `Bearer ${idToken}` },
        });

        // 2. Filter in one pass
        const upcoming = webinars.filter((webinar: any) => {
          const isTargetWebinar =
            webinar.webinarTitle
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/^-+|-+$/g, "") === params["slug"];
          const isVisible = webinar.show;
          const isFuture = new Date(webinar.eventDate) >= currentDate;
          return isTargetWebinar && isVisible && isFuture;
        });

        Id = upcoming[0].webinarId;
      }
      await axios
        .get(`${baseUrl}/webinar/` + String(Id), {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        })
        .then((webinarresponse) => {
          var webinarresponsedata = webinarresponse.data.data;

          if (webinarresponsedata.show === true) {
            setWebinarId(webinarresponsedata.id);
            setWebinartopic(webinarresponsedata.webinarTitle);
            setWebinarDate(webinarresponsedata.webinarDate);
            setWebinarPlatform(webinarresponsedata.webinarPlatform);
            setWebinarPhone(webinarresponsedata.companyPhone);
            setWebinarEmail(webinarresponsedata.companyEmail);
            setWebinarImage(webinarresponsedata.image);
            setLinkaddress(webinarresponsedata.linkaddress);
            setEventTime(webinarresponsedata.eventTime);
            setEventMeetingId(webinarresponsedata.eventMeetingId);
            setEventPasscode(webinarresponsedata.eventPasscode);
            setEventDate(webinarresponsedata.eventDate);
            if (webinarresponsedata.webinarTitle.length > 0) {
              new Promise((r) => setTimeout(r, 205));
              setReady(true);
            }
          }
        })
        .catch((error) => {
          console.error("error submitting form", error);
          setShowModal(true);
          setModalContent(getErrorMessage(error));
        });
    };
    fetch();
  }, [location.state?.Id, params]);

  const choiceGender = (gender: string) => {
    setSex(gender);
  };

  const choiceSoftque = (question: string) => {
    setSoftque(question);
  };

  const nameRegex = /^[A-Za-z\s]+$/;
  const schema: ZodType<FormData> = z.object({
    name: z
      .string()
      .min(2, { message: "Name must be at least 2 characters long" })
      .max(30, { message: "Name must not be more than 30 characters long" })
      .regex(nameRegex, {
        message: "Name must only contain alphabetic characters",
      }),
    email: z.string().email(),
    inputRequest: z.string().optional(),
    // .regex(nameRegex, { message: "Must only contain alphabetic characters" }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormData>({ resolver: zodResolver(schema) });

  const submitWebinarform = async (data: FormData) => {
    let idToken = await GetToken();
    var softquestion = "";
    var Country = "";
    var Request = "";
    if (sex.length === 0) {
      // window.scrollTo(0,130)
      setError("must be tick");
    } else {
      setError("");
    }

    if (inputphone.length < 6) {
      // window.scrollTo(0,130)
      // setNophoneerror("something wrong with the values")
      setNophoneerror(false);
    } else {
      setNophoneerror(true);
    }

    if (sex.length > 0 && inputphone.length > 6) {
      setNophoneerror(true);
      setDisablebutton(true);

      setError("");
      if (softque.length === 0) {
        softquestion = "null";
      } else {
        softquestion = softque;
      }

      if (inputCountry.length === 0) {
        Country = "null";
      } else {
        Country = inputCountry;
      }

      Request = inputRequest;

      // console.log(data.name, data.email, webinarId, sex, softquestion, Country, Request, inputphone)

      const WebinarFormData = {
        webinarid: webinarId.trim(),
        Name: data.name.trim(),
        Email: data.email.trim(),
        Gender: sex.trim(),
        Country: Country.trim(),
        Experience: softquestion.trim(),
        Request: Request.trim(),
        Phone: inputphone.trim(),
        newLetter: String(newsLetter).trim(),
      };

      const bodytouser = {
        sender: {
          name: "Doyenify Academy",
          email: "info@doyenify.com",
        },
        to: [
          {
            email: data.email,
          },
        ],
        replyTo: {
          email: "info.doyenify@gmail.com",
        },
        subject:
          "Confirmation: Registration for {{params.webinartopic}} on {{params.webinarDate}}",
        htmlContent: `<html><head>
        
                    <style>
                        body {
                            background-color:#696969;
                        }
                        .imgtag{
                            justify-content: center;
                            align-items: center;
                            margin-left: 45%;
                        }
                        .welcome {
                            text-align: center;
                            color: #696969;
                        }
                
                        .content {
                            background-color: #ffffff;
                            margin: 15px;
                            padding: 20px;
                        }
                    </style> 
                </head>
                
                <body>
                    <div class="imgtag">
                        <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
                    </div>
                    
                    <div class="content">
                        <p>Dear {{params.name}},</p> 
                        <p style="margin-bottom: 10px">Thank you for registering for our upcoming event, "{{params.webinartopic}}," 
                            which will be held on {{params.webinarDate}}. 
                            We are thrilled to have you join us for this informative session.</p>

                        <p style="margin-bottom: 5px">Here are the details you'll need to access this event:</p>
                        
                        <h5><strong>Event Title:</strong> <span style="margin-left: 7px;">{{params.webinartopic}}</span></h5>
                        <h5><strong>Date: </strong> <span style="margin-left: 7px;">{{params.eventDate}}</span></h5>
                        <h5><strong>Time: </strong> <span style="margin-left: 7px;">{{params.eventTime}}</span></h5>
                        <h5><strong>Platform: </strong> <span style="margin-left: 7px;">{{params.webinarPlatform}}</span></h5>
                        <h5><strong>MeetingId: </strong> <span style="margin-left: 7px;">{{params.eventMeetingId}}</span></h5>
                        <h5><strong>Passcode: </strong> <span style="margin-left: 7px;">{{params.eventPasscode}}</span></h5>
                        <h5><strong>Event Link: </strong> <a href={{params.linkaddress}} style="margin-left: 7px;">{{params.linkaddress}}</a></h5>

                        <p>To ensure a seamless experience, please take note of the following recommendations:</p>

                        <ol type="1">
                            <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Test Your Connection:</span> <p>We recommend joining the event a few minutes early to test your internet connection and audio settings. This will help you avoid any technical issues during the session.</p>
                            </li>
                            <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Prepare Questions: </span> <p>Our presenter will be addressing questions during the event. If you have any specific questions or topics you'd like us to cover, please feel free to reply to this email with your inquiries.</p>
                            </li>
                            <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Spread the Word:</span> <p> If you have colleagues or friends who might benefit from this event, please encourage them to register as well. The more, the merrier!</p>
                            </li>
                        </ol>

                        <p style="margin-top: 13px">We're excited to deliver valuable insights and knowledge during this event, and we look forward to your active participation.</p>


                        <p>If you encounter any issues or have questions before the event, please don't hesitate to reach out to our support team at info.doyenify@gmail.com .</p>
                        
                        <p>Thank you once again for choosing to join us for this event. We can't wait to see you there!</p>

                        <p>Best regards,</p>  
                        <p>DoyenifyAcademy</p>
                    </div> 
                
                    
                </body>
                </html>
                                
                            `,
        params: {
          webinartopic: webinartopic,
          webinarDate: webinarDate,
          webinarPlatform: webinarPlatform,
          webinarPhone: webinarPhone,
          webinarEmail: webinarEmail,
          name: data.name,
          linkaddress: linkaddress,
          eventTime: eventTime,
          eventMeetingId: eventMeetingId,
          eventPasscode: eventPasscode,
          eventDate: eventDate,
        },
      };

      const bodyToUserThreeDayReminder = {
        sender: {
          name: "Doyenify Academy",
          email: "info@doyenify.com",
        },
        to: [
          {
            email: data.email,
          },
        ],
        replyTo: {
          email: "info.doyenify@gmail.com",
        },
        subject: `Reminder: Your Webinar "{{params.webinartopic}}" is in 3 Days!`,
        htmlContent: `
          <html>
            <head>
              <style>
                body { background-color: #696969; }
                .content {
                  background-color: #ffffff;
                  margin: 15px;
                  padding: 20px;
                }
              </style>
            </head>
            <body>
              <div class="content">
                <p>Dear {{params.name}},</p>
                <p>This is a friendly reminder that you are registered for "{{params.webinartopic}}" on {{params.webinarDate}}.</p>
                <p><strong>Event Details:</strong></p>
                <ul>
                  <li><strong>Date:</strong> {{params.eventDate}}</li>
                  <li><strong>Time:</strong> {{params.eventTime}}</li>
                </ul>
                <p>We look forward to seeing you there!</p>
                <p>Best regards,</p>
                <p>Doyenify Academy</p>
              </div>
            </body>
          </html>
        `,
        params: {
          webinartopic: webinartopic,
          webinarDate: webinarDate,
          name: data.name,
          eventTime: eventTime,
          eventDate: eventDate,
        },
        scheduledAt: checkAndGetThreeDays(eventDate).threeDaysBefore,
      };

      const bodyToUserOneHourReminder = {
        sender: {
          name: "Doyenify Academy",
          email: "info@doyenify.com",
        },
        to: [
          {
            email: data.email,
          },
        ],
        replyTo: {
          email: "info.doyenify@gmail.com",
        },
        subject: `Reminder: "{{params.webinartopic}}" Starts in 1 Hour!`,
        htmlContent: `
          <html>
            <head>
              <style>
                body { background-color: #696969; }
                .content {
                  background-color: #ffffff;
                  margin: 15px;
                  padding: 20px;
                }
              </style>
            </head>
            <body>
              <div class="content">
                <p>Dear {{params.name}},</p>
                <p>Your webinar, "{{params.webinartopic}}," is starting in ONE HOUR!</p>
                <p><strong>Join Now:</strong></p>
                <ul>
                  <li><strong>Platform:</strong> {{params.webinarPlatform}}</li>
                  <li><strong>Meeting ID:</strong> {{params.eventMeetingId}}</li>
                  <li><strong>Passcode:</strong> {{params.eventPasscode}}</li>
                  <li><strong>Link:</strong> <a href="{{params.linkaddress}}">{{params.linkaddress}}</a></li>
                </ul>
                <p>Don't miss it!</p>
                <p>Doyenify Academy</p>
              </div>
            </body>
          </html>
        `,
        params: {
          webinartopic: webinartopic,
          name: data.name,
          webinarPlatform: webinarPlatform,
          eventMeetingId: eventMeetingId,
          eventPasscode: eventPasscode,
          linkaddress: linkaddress,
        },
        scheduledAt: checkAndGetOneHour(eventDate).oneHourBefore,
      };

      const bodytodoyen = {
        sender: {
          name: "Doyenify Academy Notification",
          email: "info@doyenify.com",
        },
        to: [
          {
            email: "info.doyenify@gmail.com",
          },
        ],
        replyTo: {
          email: "info.doyenify@gmail.com",
        },
        subject: "Someone registered for the Event '{{params.webinartopic}}'",
        htmlContent: `<html><head></head><body>
                                <h1>you have a newly registered webinar participant</h1>
                                <p>Participant Name: {{params.name}}, registered</p>
                                <p>Participant Email: {{params.email}}</p>
                                <p>Participant Phone Number: {{params.phone}}</p>
                                
                            </body></html>`,
        params: {
          webinartopic: webinartopic,
          name: data.name,
          email: data.email,
          phone: inputphone,
        },
      };

      axios
        .post(`${baseUrl}/webinarform`, WebinarFormData, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        })
        .then(async (response) => {
          const responseToken = await fetch(
            "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
              process.env.REACT_APP_SERVICE_KEY,
            {
              method: "post",
              body: JSON.stringify({
                email: process.env.REACT_APP_SERVICE_EMAIL,
                password: process.env.REACT_APP_SERVICE_PASSWORD,
                returnSecureToken: true,
              }),
              headers: {
                "Content-Type": "application/json",
              },
            },
          );

          const userToken = await responseToken.json();
          await axios
            .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytouser, {
              headers: { Authorization: `Bearer ${userToken.idToken}` },
            })
            .then()
            .catch(() => {
              console.log("(axios) an error occurred");
            });

          if (checkAndGetThreeDays(eventDate).hasThreeDays) {
            await axios
              .post(
                String(process.env.REACT_APP_SERVICE_APP_URL),
                bodyToUserThreeDayReminder,
                {
                  headers: { Authorization: `Bearer ${userToken.idToken}` },
                },
              )
              .then()
              .catch(() => {
                console.log("(axios) an error occurred");
              });
          }
          if (checkAndGetOneHour(eventDate).hasOneHour) {
            await axios
              .post(
                String(process.env.REACT_APP_SERVICE_APP_URL),
                bodyToUserOneHourReminder,
                {
                  headers: { Authorization: `Bearer ${userToken.idToken}` },
                },
              )
              .then()
              .catch(() => {
                console.log("(axios) an error occurred");
              });
          }

          await axios
            .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytodoyen, {
              headers: { Authorization: `Bearer ${userToken.idToken}` },
            })
            .then()
            .catch(() => {
              console.log("(axios) an error occurred");
            });

          setDisablebutton(false);
          setInputName("");
          setInputEmail("");
          setSex("");
          setInputCountry("");
          setSoftque("");
          setInputRequest("");
          setInputphone("234");
          setNewsLetter(false);
          setValueCountry("");
          reset();
          toast("Data submitted successfully");
        })
        .catch((error) => {
          toast("Something Wrong, check your network");
          console.log(error);
        });
    }
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>
      {ready ? (
        <>
          <Header />
          <ToastContainer autoClose={2000} />
          <div className="container">
            <div style={{ marginTop: "40px" }}>
              <div className="row">
                <div className="col-md-5">
                  <img
                    src={webinarImage}
                    style={{ width: "100%", marginBottom: "13px" }}
                    alt="webinnar"
                  />
                </div>
                <div className="col-md-7">
                  <div className="card" style={{ padding: "45px" }}>
                    <h3 style={{ textAlign: "center" }}>Register now</h3>
                    <hr />
                    <form onSubmit={handleSubmit(submitWebinarform)}>
                      <div className="form-row">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationServer01">
                              Name<span style={{ color: "#FF0000" }}>*</span>
                            </label>
                            <input
                              {...register("name")}
                              type="text"
                              className={
                                errors.name
                                  ? "form-control is-invalid"
                                  : "form-control is-valid"
                              }
                              id="validationServer01"
                              placeholder="Your name"
                              value={inputName}
                              onChange={(e) => setInputName(e.target.value)}
                            />
                            {errors.name && (
                              <p className="errortext">{errors.name.message}</p>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationServer02">
                              E-mail Address
                              <span style={{ color: "#FF0000" }}>*</span>
                            </label>
                            <input
                              {...register("email")}
                              type="email"
                              className={
                                errors.email
                                  ? "form-control is-invalid"
                                  : "form-control is-valid"
                              }
                              id="validationServer02"
                              placeholder="Your email"
                              value={inputEmail}
                              onChange={(e) => setInputEmail(e.target.value)}
                            />

                            {errors.email && (
                              <p className="errortext">
                                {errors.email.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          {/* <div className="col-md-4 mb-3">
                                            <label htmlFor="validationServerUsername">Username</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                <span className="input-group-text" id="inputGroupPrepend3">@</span>
                                                </div>
                                                <input type="text" className="form-control is-invalid" id="validationServerUsername" placeholder="Username" aria-describedby="inputGroupPrepend3" required />
                                                <div className="invalid-feedback">
                                                Please choose a username.
                                                </div>
                                            </div>
                                            </div> */}

                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationServer03">
                              Phone Number
                              <span style={{ color: "#FF0000" }}>*</span>
                            </label>

                            <div
                              className={
                                nophoneerror
                                  ? "textinputspwebinar"
                                  : "textinputs2pwebinar"
                              }
                              style={{ position: "relative", zIndex: 10 }} // Ensure stacking context
                            >
                              <PhoneInput
                                country={"ng"}
                                inputStyle={{ width: "90%" }}
                                dropdownStyle={{
                                  zIndex: 9999,
                                  position: "absolute",
                                }} // Overlay dropdown above others
                                value={inputphone}
                                onChange={(inputphone) =>
                                  setInputphone(inputphone)
                                }
                                isValid={(value, country: any) => {
                                  /* eslint-disable no-useless-escape */
                                  if (
                                    value.match(
                                      /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/,
                                    )
                                  ) {
                                    return (
                                      "Invalid value: " +
                                      value +
                                      ", " +
                                      country.name
                                    );
                                    /* eslint-disable no-useless-escape */
                                  } else if (
                                    value.match(
                                      /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/,
                                    )
                                  ) {
                                    return false;
                                  } else {
                                    return true;
                                  }
                                }}
                              />
                            </div>
                            {nophoneerror ? (
                              <></>
                            ) : (
                              <>
                                <p
                                  className={
                                    nophoneerror ? "errortext3" : "errortext2"
                                  }
                                >
                                  Invalid phone number
                                </p>
                              </>
                            )}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationServerUsername">
                              Gender<span style={{ color: "#FF0000" }}>*</span>
                            </label>
                            <div style={{ marginTop: "10px" }}>
                              <input
                                id="male"
                                type="radio"
                                name="gender"
                                checked={sex === "Male"}
                                onChange={(e) => {}}
                                onClick={() => {
                                  choiceGender("Male");
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>Male</span>
                              <br />
                            </div>

                            <div style={{ marginTop: "10px" }}>
                              <input
                                id="female"
                                type="radio"
                                name="gender"
                                checked={sex === "Female"}
                                onChange={(e) => {}}
                                onClick={() => {
                                  choiceGender("Female");
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>Female</span>
                              <br />
                            </div>
                            <p className="errortext">{error}</p>
                          </div>
                        </div>

                        <div className="row">
                          {/* <div className="col-md-4 mb-3">
                                            <label htmlFor="validationServerUsername">Username</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                <span className="input-group-text" id="inputGroupPrepend3">@</span>
                                                </div>
                                                <input type="text" className="form-control is-invalid" id="validationServerUsername" placeholder="Username" aria-describedby="inputGroupPrepend3" required />
                                                <div className="invalid-feedback">
                                                Please choose a username.
                                                </div>
                                            </div>
                                            </div> */}
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationServerUsername">
                              Do you have a specific request
                            </label>
                            <div className="input-group">
                              <textarea
                                {...register("inputRequest")}
                                className={"form-control is-valid"}
                                id="validationServerUsername"
                                placeholder="Your request"
                                aria-describedby="inputGroupPrepend3"
                                value={inputRequest}
                                onChange={(e) =>
                                  setInputRequest(e.target.value)
                                }
                                rows={3}
                              />
                            </div>
                          </div>

                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationServer03">
                              Do you have any experience in IT?
                            </label>
                            <div style={{ marginTop: "10px" }}>
                              <input
                                id="software"
                                type="radio"
                                name="coding"
                                checked={softque === "Yes"}
                                onChange={(e) => {}}
                                onClick={() => {
                                  choiceSoftque("Yes");
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>Yes</span>
                              <br />
                            </div>

                            <div style={{ marginTop: "10px" }}>
                              <input
                                id="software"
                                type="radio"
                                name="coding"
                                checked={softque === "No"}
                                onChange={(e) => {}}
                                onClick={() => {
                                  choiceSoftque("No");
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>No</span>
                              <br />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationServer03">Country</label>
                            {/* <input type="text" className="form-control" id="validationServer03" placeholder="Your country"   value={inputCountry} onChange={(e) => setInputCountry(e.target.value)} /> */}

                            <Select
                              options={options}
                              value={valueCountry}
                              onChange={changeHandler}
                            />
                          </div>

                          <div className="col-md-6"></div>
                        </div>
                      </div>

                      <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                        <input
                          type="checkbox"
                          checked={newsLetter}
                          onClick={subscribetonewsletter}
                        />{" "}
                        <span>Tick to subscribe to our NewsLetter</span>
                      </div>
                      <button
                        type="submit"
                        disabled={disablebutton}
                        className="btn btn-success"
                      >
                        Submit form
                      </button>
                    </form>
                  </div>
                </div>
              </div>

              {/* <img src="../../images/doyenifyAcademy.png" alt="doyenacadlogo" />
                        <h1>{webinartopic}</h1>
                        <h4>Event Timing: {webinarDate}</h4>
                        <h4>Event Address: {webinarPlatform}</h4>
                        <h4>Contact us: <img src="../../images/whatsapp.png" style={{marginRight: "10px", marginLeft: "10px", height: "20px", display: "inline"}} alt="whatsap" />
                        <a style={{textDecoration: "none"}} href="https://api.whatsapp.com/send?phone=37256704920"  target="_blank"  rel="noreferrer"><span style={{color: "#696969", cursor: "pointer"}}>+{webinarPhone}</span></a>
                          <span style={{marginLeft: "7px"}}>or</span> <p style={{color: "#696969", display: "inline", cursor: "pointer"}} onClick={toGmailsite}>{webinarEmail}</p></h4>
                        

                        <form onSubmit={handleSubmit(submitWebinarform)}>
                            <div style={{marginTop: "30px", padding: "20px", boxShadow: "0 0px 20px 0 rgba(0,0,0,0.2)", borderRadius: "9px"}}>
                                <h4 style={{marginBottom: "28px"}}>Name<span style={{color: "#FF0000"}}>*</span></h4>
                                <input  {...register("name")} style={{width: "70%", height: "50px", borderRadius: "7px", backgroundColor: "#EDECF8", border: "1px solid #EDECF8" }} type="text" placeholder="Your Name"  value={inputName}    onChange={(e) => setInputName(e.target.value)}/>
                                {errors.name && <p  className="errortext">{errors.name.message}</p>}

                            </div>

                            <div style={{marginTop: "30px", padding: "20px", boxShadow: "0 0px 20px 0 rgba(0,0,0,0.2)", borderRadius: "9px"}}>
                                <h4 style={{marginBottom: "28px"}}>E-mail Address<span style={{color: "#FF0000"}}>*</span></h4>
                                <input  {...register("email")} style={{width: "70%", height: "50px", borderRadius: "7px", backgroundColor: "#EDECF8", border: "1px solid #EDECF8"}} type="email" placeholder="Your Email"  value={inputEmail}    onChange={(e) => setInputEmail(e.target.value)}/>
                                {errors.email && <p  className="errortext">{errors.email.message}</p>}

                            </div>

                            <div style={{marginTop: "30px", padding: "20px", boxShadow: "0 0px 20px 0 rgba(0,0,0,0.2)", borderRadius: "9px"}}>
                                <h4 style={{marginBottom: "28px"}}>Gender<span style={{color: "#FF0000"}}>*</span></h4>
                                <div style={{marginTop: "10px"}}>
                                    <input  id="male"  type="radio" name="gender" checked={sex === 'Male'}  onChange={e => {}}  onClick={() => {choiceGender("Male")}}/><span style={{marginLeft: "10px"}}>Male</span><br/>
                                </div>
                                
                                <div style={{marginTop: "10px"}}>
                                    <input id="female" type="radio" name="gender" checked={sex === 'Female'} onChange={e => {}} onClick={() => {choiceGender("Female")}}/><span style={{marginLeft: "10px"}}>Female</span><br/>
                                
                                </div>
                                <p  className="errortext">{error}</p>

                                      
                            </div>

                            <div style={{marginTop: "30px", padding: "20px", boxShadow: "0 0px 20px 0 rgba(0,0,0,0.2)", borderRadius: "9px"}}>
                                <h3 style={{marginBottom: "28px"}}>Country</h3>
                                <input style={{width: "70%", height: "50px", borderRadius: "7px", backgroundColor: "#EDECF8", border: "1px solid #EDECF8"}} type="text" placeholder="Your Country"   value={inputCountry} onChange={(e) => setInputCountry(e.target.value)}/>
                            </div>

                            <div style={{marginTop: "30px", padding: "20px", boxShadow: "0 0px 20px 0 rgba(0,0,0,0.2)", borderRadius: "9px"}}>
                                <h3 style={{marginBottom: "28px"}}>Do you have any experience in software engineering field</h3>
                                <div style={{marginTop: "10px"}}>
                                    <input  id="software"  type="radio" name="coding" checked={softque === 'Yes'}  onChange={e => {}}  onClick={() => {choiceSoftque("Yes")}}/><span style={{marginLeft: "10px"}}>Yes</span><br/>
                                </div>
                                
                                <div style={{marginTop: "10px"}}>
                                    <input id="software" type="radio" name="coding" checked={softque === 'No'} onChange={e => {}} onClick={() => {choiceSoftque("No")}}/><span style={{marginLeft: "10px"}}>No</span><br/>
                                
                                </div>
                            </div>

                            <div style={{marginBottom: "15px", marginTop: "30px", padding: "20px", boxShadow: "0 0px 20px 0 rgba(0,0,0,0.2)", borderRadius: "9px"}}>
                                <h3 style={{marginBottom: "28px"}}>Do you have a specific request</h3>
                                <input style={{width: "70%", height: "50px", borderRadius: "7px", backgroundColor: "#EDECF8", border: "1px solid #EDECF8"}} type="text" placeholder="Your Request"  value={inputRequest} onChange={(e) => setInputRequest(e.target.value)}/>
                            </div>

                            <button type="submit" disabled={disablebutton} className="btn btn-success" style={{padding: "10px", fontSize: "18px"}}>Submit</button>
                        </form> */}
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />

          <Footer />
        </>
      ) : (
        <>
          <div>
            {/* <Audio
                        height="80"
                        width="80"
                        // radius="9"
                        color="green"
                        ariaLabel="loading"
                        wrapperStyle={{alignItems: "center", justifyContent: "center",verticalAlign: "middle", margin: "auto", position: "absolute",
                        top: "0", left: "0", bottom: "0", right: "0"}}
                        // wrapperClass
                        /> */}

            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default WebinarForm;
